export { FranchiseProjectCard } from './FranchiseProjectCard'
export type { FranchiseProjectCardProps } from './FranchiseProjectCard'
